export const NOTIFICATIONS_BATCH_SIZE = 20
